package nacholab.supplies.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.layout.ModifierInfo
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import nacholab.supplies.ui.theme.SuppliesTheme
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.NumberInput
import org.jetbrains.compose.web.dom.TextInput

@Composable
fun CellText(text: String?, modifier: Modifier = Modifier){
    SpanText(
        text = text?:"",
        modifier = modifier
            .color(SuppliesTheme.colors.background)
            .fontSize(18.px)
    )
}

@Composable
fun CellTextInput(
    value: String?,
    onInput: (String) -> Unit,
    onFocusIn: () -> Unit,
    onFocusOut: () -> Unit,
    modifier: Modifier = Modifier
){
    TextInput(
        value = value ?: "",
        attrs = modifier
            .color(SuppliesTheme.colors.background)
            .fontSize(18.px)
            .toAttrs {
                onInput { t -> onInput(t.value) }
                onFocusIn { _ -> onFocusIn() }
                onFocusOut { _ -> onFocusOut() }
            }
    )
}

@Composable
fun CellNumberInput(value: Int?, modifier: Modifier = Modifier, onChange: (Int) -> Unit){
    NumberInput(
        value = value ?: 0,
        attrs = modifier
            .color(SuppliesTheme.colors.background)
            .fontSize(18.px)
            .toAttrs {
                onInput { t -> onChange(t.value?.toInt()?:0) }
            }
    )
}

